import { createAction, createAsyncAction } from 'lib/store-utils';
import { GetPageDataSuccessPayload } from './types';
import { FormattedErrors } from 'type';

export const BOX_PAY_CONDITIONS_PAGE_DATA_GET = createAsyncAction<void, GetPageDataSuccessPayload, FormattedErrors>('Settings / Pay Conditions page / get page data');
export const BOX_PAY_CONDITIONS_PAGE_ERRORS_CLOSED = createAction('Settings / Pay Conditions page / errors closed');
export const BOX_PAY_CONDITIONS_PAGE_DIALOG_ERRORS_CLOSED = createAction('Settings / Pay Conditions page / dialog / errors closed');
export const BOX_PAY_CONDITIONS_PAGE_DIALOG_OPENED = createAction('Settings / Pay Conditions page / dialog / opened');
